var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignaturesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#F1EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7788 28.2183L14.4561 21.7589L18.244 25.5434L11.7788 28.2183ZM20.4994 27.0791L21.9886 23.4678L16.447 17.938L12.8301 19.4372L10 16.6074L27.2634 10L30 12.7341L23.3979 30L20.4994 27.0791Z",
    fill: "#C9B3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignaturesMenu);
export default __webpack_public_path__ + "static/media/signatures-menu.fe83f9bbb64c20362867d6b3cb7713bc.svg";
export { ForwardRef as ReactComponent };